// import BionicLogo from '../BionicUI/bionicLogo/BionicLogo';
import { Flip } from 'gsap/Flip';
import gsap from 'gsap';
import { cn } from '../../lib/utils';
import { useEffect, useState } from 'react';
import useOnboardingStore from 'stores/onboardingStore';
import { useAudioPlayer } from 'react-use-audio-player';
import { useGSAP } from '@gsap/react';
import useAudioStore from 'stores/audioStore';

gsap.registerPlugin(Flip);

type AnimState = {
  container: string;
  logo: string;
};

const anim = {
  from: {
    container: 'absolute items-center',
    logo: 'w-[20vw] min-w-[180px]',
  },
  to: {
    container: 'relative items-start',
    logo: 'w-[10vw] min-w-[150px]',
  },
};

const LogoBar = () => {
  const { rotateVault, setShowInputSequence } = useOnboardingStore();

  const drone = useAudioPlayer();
  const { masterVolume } = useAudioStore();
  const [droneRespectMasterVolume, setDroneRespectMasterVolume] =
    useState<boolean>(false);

  useEffect(() => {
    if (!droneRespectMasterVolume || !drone) return;
    if (droneRespectMasterVolume) drone.setVolume(masterVolume * 0.5);
  }, [masterVolume, drone, droneRespectMasterVolume]);

  const [style, setStyle] = useState<AnimState>(anim.from);
  const [flipState, setFlipState] = useState<Flip.FlipState>(
    {} as Flip.FlipState
  );
  const [hasStarted, setHasStarted] = useState<boolean>(false);
  // const [animateLogo, setAnimateLogo] = useState<boolean>(true);

  const animate = () => {
    const state = Flip.getState('#logo');
    // setAnimateLogo(false);
    setFlipState(state);
    setStyle(anim.to);
  };

  useEffect(() => {
    animate();
  }, []);

  useGSAP(() => {
    if (hasStarted || style !== anim.to) return;
    setHasStarted(true);

    drone.load(`${process.env.PUBLIC_URL}/sound/intro/bg-drone.wav`, {
      loop: true,
      initialVolume: 0,
    });

    Flip.from(flipState, {
      duration: 0.9,
      ease: 'power3.inOut',
      onStart: () => {
        // drone.play();
        setTimeout(() => drone.fade(0, 0.5, 200), 200);
        setTimeout(() => setDroneRespectMasterVolume(true), 400);
      },
      onComplete: () => {
        rotateVault(35);
        setShowInputSequence(true);
      },
    });
  }, [style]);

  return (
    <div
      id="logo-container"
      className={cn(
        'grid w-full h-full justify-center cursor-pointer',
        style.container
      )}
      onClick={animate}
    >
      {/* <BionicLogo className={style.logo} animate={animateLogo} /> */}
      <img
        src="/images/ground-zero-logo.svg"
        alt=""
        className="h-[42px] w-[174px] object-none"
      />
    </div>
  );
};

export default LogoBar;
